export const redirects = {
  bookshelf: "Du wirst nun zum Bücherregal weitergeleitet.",
  library: "Du wirst nun zur Bibliothek weitergeleitet.",
  landing_page: "Du wirst nun zur Startseite weitergeleitet.",
};
